import BaseShopLayout from "@shop/components/BaseShopLayout";
import PackageSelection from "@shop/components/PackageSelection";

const SaasShopPage = () => {
    return (
        <BaseShopLayout
            title={"Passe hier Deinen Bedarf an – flexibel und unkompliziert!"}
            description={
                "Wenn Du feststellst, dass Ihr weitere Nutzerzugänge benötigt, kannst Du diese hier ganz einfach dazubuchen. Anschließend lassen sich die neuen Zugänge direkt in der Nutzerverwaltung zuweisen."
            }
            useOuterScroll
        >
            <PackageSelection />
        </BaseShopLayout>
    );
};

export default SaasShopPage;
